import React from 'react'
import './cart.css'


export const cart=[];

const Carts = () => {
    
   
  return (
    <div className='cartcount'>
        <p>{cart.length}</p>

      
    </div>
  )
}

export default Carts
